import React, { Component } from 'react';
import * as Styles from './Styles';
import Banner from './banner/Banner';
import Schemas from './schemas/Schemas';
import Info from './info/Info';
import Duties from './duties/Duties';

type Props = {};

type State = {};

class ReportView extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Styles.Wrapper>
				<Banner />
				<Schemas />
				<Info />
				<Duties />
			</Styles.Wrapper>
		);
	}
}

export default ReportView;
